/**
 * Shopify Forms injects a body-level hCaptcha/reCAPTCHA wrapper. While dormant it
 * can still receive pointer events (often via a full-viewport fixed child), which
 * steals header dropdown hover on pages that embed a form.
 *
 * theme.liquid keeps dormant wrappers inert (pointer-events: none, low z-index).
 * This script adds .rm-captcha-active only when a real challenge is visible so
 * customers can still complete captcha.
 */
(function neutralizeDormantCaptchaOverlays() {
  var ACTIVE_CLASS = 'rm-captcha-active';

  function isCaptchaIframe(iframe) {
    return /hcaptcha|recaptcha/i.test((iframe.src || '') + (iframe.title || ''));
  }

  function captchaIframes() {
    var list = [];

    document.querySelectorAll('iframe').forEach(function(iframe) {
      if (isCaptchaIframe(iframe)) {
        list.push(iframe);
      }
    });

    document.querySelectorAll('shopify-forms-embed').forEach(function(embed) {
      if (!embed.shadowRoot) {
        return;
      }

      embed.shadowRoot.querySelectorAll('iframe').forEach(function(iframe) {
        if (isCaptchaIframe(iframe)) {
          list.push(iframe);
        }
      });
    });

    return list;
  }

  function wrapperFor(iframe) {
    if (iframe.closest) {
      var bodyChild = iframe.closest('body > div');
      if (bodyChild) {
        return bodyChild;
      }
    }

    var node = iframe.parentElement;
    while (node && node.parentElement && node.parentElement !== document.body) {
      node = node.parentElement;
    }

    return node && node.parentElement === document.body ? node : null;
  }

  function isVisibleChallenge(iframe) {
    var style = window.getComputedStyle(iframe);
    var rect = iframe.getBoundingClientRect();

    if (style.visibility === 'hidden' || style.display === 'none' || parseFloat(style.opacity) < 0.2) {
      return false;
    }

    if (rect.width < 50 || rect.height < 50) {
      return false;
    }

    if (rect.bottom <= 0 || rect.top >= window.innerHeight) {
      return false;
    }

    var wrapper = wrapperFor(iframe);
    if (wrapper && wrapper.getAttribute('aria-hidden') === 'true') {
      return false;
    }

    return true;
  }

  var capScheduled = false;

  function sync() {
    var activeWrappers = new Set();

    captchaIframes().forEach(function(iframe) {
      var wrapper = wrapperFor(iframe);
      if (!wrapper) {
        return;
      }

      if (isVisibleChallenge(iframe)) {
        activeWrappers.add(wrapper);
      }
    });

    document.querySelectorAll('body > div.' + ACTIVE_CLASS).forEach(function(wrapper) {
      if (!activeWrappers.has(wrapper)) {
        wrapper.classList.remove(ACTIVE_CLASS);
      }
    });

    activeWrappers.forEach(function(wrapper) {
      wrapper.classList.add(ACTIVE_CLASS);
    });
  }

  function syncSoon() {
    if (capScheduled) {
      return;
    }

    capScheduled = true;
    window.requestAnimationFrame(function() {
      capScheduled = false;
      sync();
    });
  }

  function observe() {
    var observer = new MutationObserver(syncSoon);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'aria-hidden', 'hidden']
    });
  }

  function start() {
    sync();
    observe();
    document.addEventListener('submit', syncSoon, true);
    window.addEventListener('resize', syncSoon);
    window.addEventListener('orientationchange', syncSoon);
  }

  if (!document.body) {
    document.addEventListener('DOMContentLoaded', start);
    return;
  }

  start();
})();
